import { useContext } from 'react';
import TranslationContext, { TranslationData } from './TranslationContext';

const getTranslation = (
  key: string,
  translations: { [key: string]: string }
): string => {
  const translation = translations[key];

  if (typeof translation === 'undefined' && typeof console !== 'undefined') {
    // eslint-disable-next-line no-console
    console.warn('Translation missing:', key);
  }

  return translation || '';
};

function useTranslation() {
  const context = useContext<TranslationData>(TranslationContext);

  if (context === undefined) {
    throw new Error('useTranslations: TranslationProvider missing');
  }

  return {
    translate: (key: string) => getTranslation(key, context.messages)
  };
}

export default useTranslation;
